export default {"src":"/_next/static/media/0xb753428af26e81097e7fd17f40c88aaa3e04902c.93805349.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};